import React from 'react'
import ActionButton from 'uiComponents/buttons'
import { Col, Row } from 'uiComponents/flex'
import { ModalDialogTitle } from 'uiComponents/popups/modal'
import { Headline } from 'uiComponents/typography'
import { DiscountPool } from 'discounts/types'
import { removeHash, setHash } from 'utils/hash'
import { Trans, useTranslation } from 'translations'

interface AddPoolSuccessfulProps {
    pool?: DiscountPool
}

const AddPoolSuccessful: React.FC<AddPoolSuccessfulProps> = ({ pool }) => {
    const { t } = useTranslation()
    const addDiscounts = () => {
        setHash('add_discount', { poolUuid: pool?.uuid ?? '' })
    }

    return (
        <>
            <ModalDialogTitle>{t('discounts.addPool.successTitle')}</ModalDialogTitle>
            <Headline size={6} style={{ wordBreak: 'break-word' }}>
                {pool?.name ? (
                    <Trans
                        i18nKey="discounts.addPool.successBodyWithName"
                        values={{ name: pool.name }}
                        components={{ b: <b /> }}
                    />
                ) : (
                    t('discounts.addPool.successBody')
                )}
            </Headline>
            <Row align="flex-end" style={{ paddingTop: '32px' }}>
                <Col span="auto">
                    <ActionButton size="large" secondary onClick={removeHash}>
                        {t('common.cancel')}
                    </ActionButton>
                </Col>
                <Col span="auto">
                    <ActionButton size="large" onClick={addDiscounts}>
                        {t('discounts.addPool.addDiscounts')}
                    </ActionButton>
                </Col>
            </Row>
        </>
    )
}

export default AddPoolSuccessful
